import * as actions from './actions'
import axios from 'axios'
import Cookies from 'js-cookie'

const INITIAL_STATE = JSON.parse(localStorage.getItem('state')) || 
{
    access_token: '',
    username: '',
    premium: false,
}

axios.defaults.headers.common['Authorization'] = INITIAL_STATE.access_token
const explicitApiBaseUrl = process.env.REACT_APP_API_BASE_URL
if (explicitApiBaseUrl) {
    axios.defaults.baseURL = explicitApiBaseUrl
}
Cookies.set('access_token', INITIAL_STATE.access_token)

const reducer = (state = INITIAL_STATE, action) => {
    switch(action.type){
        case actions.SET_LOGIN_DATA:
            axios.defaults.headers.common['Authorization'] = action.access_token
            Cookies.set('access_token', action.access_token)
            return {...state, access_token: action.access_token, username: action.username, premium: action.premium}
        case actions.CLEAR_LOGIN_DATA:
            axios.defaults.headers.common = {}
            Cookies.remove('access_token')
            return {...state, access_token: '', username: '', premium: false}
    }
    return state
}

export default reducer